import { Theme } from "@mui/material";

export const getCardStyles = (theme: Theme) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: 3,
  padding: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
  boxSizing: "border-box",
});

export const imageStyles = {
  width: { xs: 24, md: 32 },
  height: { xs: 24, md: 32 },
  mb: { xs: 3, md: 3.25 },
};
